import { useEffect } from 'react';

type UseRedirectArguments = {
  shouldRedirect: boolean;
  path?: string;
};

/**
 * useRedirect is a hook that will redirect a page if the component chooses to
 */
export const useRedirect = ({
  path = '/',
  shouldRedirect,
}: UseRedirectArguments) => {
  useEffect(() => {
    if (shouldRedirect) {
      window.location.replace(path);
    }
  }, [path, shouldRedirect]);
};
